/**
 * @fileoverview useLanguage — i18n ↔ Redux dil senkronizasyonu.
 * Dil listesi CMS (`public/languages.php` → siteLocale slice); yoksa tr/en/ru varsayılanı slice’ta tutulur.
 */

import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setLanguage, selectCurrentLanguage } from '../features/language/languageSlice'
import { selectSiteLanguages } from '../features/siteLocale/siteLocaleSlice'
import { ensureLocalesLoaded } from '../i18n/ensureLocalesLoaded.js'

/**
 * @returns {{
 *   currentLanguage: string,
 *   changeLanguage:  (lang: string) => Promise<void>,
 *   languages:       string[],
 *   languageList:    { code: string, name: string }[],
 * }}
 */
export const useLanguage = () => {
  const dispatch         = useDispatch()
  const currentLanguage  = useSelector(selectCurrentLanguage)
  const languageList     = useSelector(selectSiteLanguages)
  const { i18n }         = useTranslation()

  /**
   * Dil değiştirir: Redux → i18next → HTML lang attribute
   * @param {string} lang
   */
  const changeLanguage = useCallback(
    async (lang) => {
      dispatch(setLanguage(lang))
      await ensureLocalesLoaded(lang)
      await i18n.changeLanguage(lang)
      document.documentElement.lang = lang
    },
    [dispatch, i18n]
  )

  return {
    currentLanguage,
    changeLanguage,
    languages: languageList.map((x) => x.code),
    languageList,
  }
}
